import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import AppShell from "@/components/shell/app-shell.vue";
import PageNotFound from "@/components/common/page-not-found.vue";
import Unauthorized from "@/components/auth/unauthorized-page.vue";
import AuthCallback from "@/components/auth/auth-callback.vue";
import { authGuard } from "@auth0/auth0-vue";
import ErrorPage from "@/components/common/error-page.vue";

/* Lazy loading routes */
const VerificationPortal = () => import("@/components/claims/verification-portal.vue");
const VerificationEditContainer = () => import("@/components/verification/verification-edit.vue");
const VerificationAddContainer = () => import("@/components/verification/verification-add.vue");
const VerificationClaims = () => import("@/components/claims/verification-claims.vue");

const routes: Array<RouteRecordRaw> = [
	{
		path: "/",
		redirect: "/home",
		name: "AppShell",
		component: AppShell,
		beforeEnter: authGuard,
		children: [
			{
				path: "/home",
				name: "Home",
				component: VerificationPortal,
				beforeEnter: authGuard,
			},
			{
				path: "/verification",
				name: "verificationList",
				component: VerificationPortal,
				beforeEnter: authGuard,
			},
			{
				path: "/verification/add",
				name: "verificationAdd",
				component: VerificationAddContainer,
				beforeEnter: authGuard,
			},
			{
				path: "/verification/edit/:id",
				name: "verificationEdit",
				component: VerificationEditContainer,
				beforeEnter: authGuard,
			},
			{
				path: "/claims",
				name: "verificationClaims",
				component: VerificationClaims,
				beforeEnter: authGuard,
			},
			{
				path: "/error",
				name: "ErrorPage",
				component: ErrorPage,
			},
			{
				path: "/testing",
				component: VerificationPortal,
				beforeEnter: () => {
					throw new Error("This is a test router error");
				},
			},
		],
	},
	{
		path: "/auth-callback",
		name: "AuthCallback",
		component: AuthCallback,
	},
	{
		path: "/unauthorized",
		name: "Unauthorized",
		component: Unauthorized,
	},
	{
		path: "/:pathMatch(.*)*",
		name: "PageNotFound",
		component: PageNotFound,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

export default router;
